import { apacTheme_css } from "./apac/apacTheme.css.mjs";
import { seekJobs_css } from "./seekJobs/seekJobs.css.mjs";
import { seekBusinessTheme_css } from "./seekBusiness/seekBusinessTheme.css.mjs";
import { wireframe } from "./wireframe/wireframeTheme.css.mjs";
import { docsTheme_css } from "./docs/docsTheme.css.mjs";
const themes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apac: apacTheme_css,
  docs: docsTheme_css,
  seekBusiness: seekBusinessTheme_css,
  seekJobs: seekJobs_css,
  wireframe
}, Symbol.toStringTag, { value: "Module" }));
export {
  themes
};
